export class DropdownCustom {
  constructor({containerSelector = '[data-dropdown]',
              triggersSelector = '[data-dropdown-trigger]',
              menuSelector = '[data-dropdown-content]',
              activeClass = 'active'})
  {
    this.containerSelector = containerSelector
    this.triggersSelector = triggersSelector
    this.menuSelector = menuSelector
    this.activeClass = activeClass

    this.triggers = document.querySelectorAll(this.triggersSelector)
    this.prevOpened = null

    this.init()
  }

  init() {
    this.triggers.forEach(trigger => {
      const dropdown = trigger.parentNode

      trigger.addEventListener('click', () => {
        this.closePrev(dropdown)
        this.dropdownChange(dropdown, 'toggle')
      })
    })

    window.addEventListener('click', (event) => {
      if (!this.prevOpened) return

      let current = event.target.closest(this.containerSelector)
      if (current && current.classList === this.prevOpened.classList) {
        return
      }
      this.closePrev(current)
    })
  }

  dropdownChange(dropdown, action) {
    const menu = dropdown.querySelector(this.menuSelector)

    if (action === 'toggle') {
      dropdown.classList.toggle(this.activeClass)
      menu.classList.toggle(this.activeClass)
    }
    if (action === 'close') {
      dropdown.classList.remove(this.activeClass)
      menu.classList.remove(this.activeClass)
    }

    if (dropdown.classList.contains(this.activeClass)) {
      this.prevOpened = dropdown
    }
  }

  closePrev(currentOpened) {
    if (this.prevOpened && currentOpened !== this.prevOpened) {
      this.dropdownChange(this.prevOpened, 'close')
      this.prevOpened = false
    }
  }
}
